import * as yup from 'yup';

export const rolloutBehaviorValidationSchema = yup.object({
  restartPodsOneByOne: yup.boolean().required(),
  zeroDowntime: yup.boolean().required(),
  delaySecondsEnabled: yup.boolean().required(),
  delaySeconds: yup.object().shape({
    isCustom: yup.boolean().required(),
    minutes: yup.number().min(0).max(60).required(),
    seconds: yup.number().min(0).max(59).required(),
  }),
});
